<script setup>
import Setup from './Setup.vue';
import { useDesignLabStore } from "../DesignLabStore.js"
import { onMounted, ref, defineEmits } from 'vue';
import CounterGroup from "./CounterGroup.vue";
import {storeToRefs} from 'pinia'

const designLabStore = useDesignLabStore();

const emit = defineEmits(["IncrementItem"]);

const addToCart = () => {
  if (!designLabStore.checkLineItems()) {
    return;
  }

  designLabStore.goToNextSetup();
};

const handleUpdateItem = (updatedItem) => {
  const index = designLabStore.lineItems.findIndex(item => item.size_id === updatedItem.size_id);
  if (index !== -1) designLabStore.lineItems[index] = updatedItem;
};

onMounted(async () => {
  await designLabStore.getDesignCheckInfo(false);
});

</script>

<template>
  <Setup title="尺寸及數量確認">
    <template #content>
      <!-- 圖片展示 -->
      <div id="design-carousel" class="carousel mk-carousel slide design-lab-carousel">
        <!-- 主要圖片顯示區 -->
        <div class="carousel-inner">
          <div v-for="(url, index) in designLabStore.previewImages" :key="`m${index}`" :class="{ 'active': index == 0 }"
            class="carousel-item">
            <div class="mk-carousel__image">
              <div class="mk-image-box">
                <img :src="url" loading="lazy" v-if="url">
                <img src="https://placehold.co/200" loading="lazy" v-else>
              </div>
            </div>
          </div>
        </div>

        <!-- 顯示前一個圖片的按鍵 -->
        <button type="button" class="carousel-control-prev" data-bs-target="#design-carousel" data-bs-slide="prev">
          <span class="carousel-control-prev-icon"></span>
        </button>

        <!-- 顯示後一個圖片的按鍵 -->
        <button type="button" class="carousel-control-next" data-bs-target="#design-carousel" data-bs-slide="next">
          <span class="carousel-control-next-icon"></span>
        </button>

        <!-- 預覽圖片 -->
        <div class="carousel-indicators">
          <div class="carousel-indicators-inner">
            <button type="button" data-bs-target="#design-carousel" :data-bs-slide-to="index"
              v-for="(url, index) in designLabStore.previewImages" :key="`p${index}`" :class="{ 'active': index == 0 }">
              <img :src="url" loading="lazy" v-if="url">
              <img src="https://placehold.co/80" loading="lazy" v-else>
            </button>
          </div>
        </div>

      </div>

      <!-- 產品資訊 -->
      <div style="padding: 0 1rem">
        
        <h2 class="mk-text-black">規格：{{ designLabStore.design.sku }}</h2>
        <h2 class="mk-text-black">原價：<span class="mk-price">${{ designLabStore.checkInfo.priceWithAreas }}</span></h2>

        <!-- 折扣區間  -->
        <div class="accordion accordion-flush mk-accordion">
          <div class="accordion-item">
            <div class="accordion-header">
              <button class="accordion-button" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapse-design-discount-info">
                <div class="mk-text-black">折扣區間</div>
              </button>
            </div>

            <div class="accordion-collapse collapse show" id="collapse-design-discount-info">
              <div class="accordion-body">
                <div class="row justify-content-end my-1" style="color: #EE7C26 ;font-size: 0.8rem;">
                  合併折扣-適用所有訂單總數量</div>
                <div class="row">
                  <table class="table table-bordered text-center">
                    <thead>
                      <tr class="bg-mok text-white">
                        <td scope="col">件數</td>
                        <td scope="col">折扣區間</td>
                        <td scope="col">製作天數</td>
                        <td scope="col">合併折扣</td>
                        <td scope="col">參考價</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in designLabStore.checkInfo.amountPriceInfo"
                        :key="`amountPriceInfo${index}`">
                        <td class="table-secondary">{{ item.title }}</td>

                        <td class="table-light" :style="item.extraPrice ? 'color: #EE7C26;' : ''">{{
                          item.procDesc }}</td>
                        <td class="table-light" :style="item.extraPrice ? 'color: #EE7C26;' : ''">{{
                          item.deliveryDate }}</td>
                        <td class="table-light" :style="item.extraPrice ? 'color: #EE7C26;' : ''">{{
                          item.mergeDiscount ? "✓" : "☓" }}</td>
                        <td class="table-light" :style="item.extraPrice ? 'color: #EE7C26;' : ''">{{
                          item.price }}</td>
                      </tr>
                      <tr>

                        <td class="table-light fs-10" colspan="5">
                          <!-- 目前先不動態調整 -->
                          單款採購未滿五件, 每件需加+300版費, 且不列入總數量合併折扣
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 尺寸選擇 -->
        <div class="accordion accordion-flush mk-accordion">
          <div class="accordion-item">
            <div class="accordion-header">
              <button class="accordion-button" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapse-design-product-info2">
                <div> <span class="mk-text-black">尺寸選擇</span> <span class="mk-price">未滿五件，每件需要+300元版費</span> </div>
              </button>
            </div>

            <div class="accordion-collapse collapse show" id="collapse-design-product-info2">
              <!-- line items -->
              <CounterGroup :lineItems="designLabStore.lineItems" @updateItem="handleUpdateItem" />
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #action>
      <!-- 動作 -->
      <div class="mk-btn-group w-100">
        <button @click="addToCart()" class="mk-btn w-100">加入購物車</button>
      </div>
    </template>
  </Setup>
</template>

<style scoped>
.mk-text-black {
  color: #666666;
}

.table-bordered>:not(caption)>*>* {
    border-width: 1px;
}

.fs-10 {
  font-size: 10pt;
}
</style>